import React, { Component } from 'react';
import './Home.scss';
import AboutUsSection from './HomeElements/AboutUs';
import HomeDonateSection from './HomeElements/HowToDonate';
import SponsorSection from './HomeElements/HomeSponsor';
import { Element } from 'react-scroll';
import VideoSection from './HomeElements/VideoSection';

class Home extends Component {
  render() {
    return (
      <div>
        <Element name="about-us-section">
	  <AboutUsSection />
	  <VideoSection />
        </Element>
        <HomeDonateSection />
        <SponsorSection />
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Containers/Home.js